import { Box, Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import AnimatedTypography from '../../core/AnimatedTypography';
import SpecificOfferSection from './SpecificOfferSection';

interface SpecificOfferSummaryProps {
}

const SpecificOfferSummary: React.FC<SpecificOfferSummaryProps> = ({ }) => {
    const { t } = useTranslation();
    return (
        <Grid
            sx={{

                // backdropFilter: { xs: "blur(16px)", md: "none" },
                // backgroundColor: "#ffffff63"
            }}
            pt={4}
            pb={6}
            px={0}
            container
            direction={"column"}
            alignItems={"start"}
            justifyContent={"start"}
            width={"100%"}>
            <Box width={"100%"} p={0}>
                <AnimatedTypography variant='h3' color={"text2.primary"} fontWeight={600}>{t("specificOffer.title")}</AnimatedTypography>

                <SpecificOfferSection />
            </Box>
        </Grid >
    )
}

export default SpecificOfferSummary;